<template lang="html">
  <div class="row transaction-results-details">
    <div class="small-12 medium-12 large-12 columns">
      <div v-for="(value, prop) in selectedRecords" class="row record-text">
        <div class="small-9 medium-7 large-7 columns">
          <span v-if="isBgColor(prop)" class="bg-color float-right transaction-details">outstanding on {{outstanding(prop)}}</span>
          <span v-else class="float-right transaction-details">{{prop}} {{fromFormat}}-{{toFormat}}</span>
        </div>
        <div class="small-3 medium-5 large-5 columns">
          <span :class="['float-left', 'detail-value', { ['bg-color']: isBgColor(prop) }]">{{value || 0}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: {
    records: Object
  },

  name: 'transaction-results-details',

  methods: {
    isBgColor(prop) {
      return prop == 'outstanding_points_from' || prop == 'outstanding_points_to'
    },

    outstanding(prop) {
      if (prop == 'outstanding_points_from') {
        return this.fromFormat
      } else {
        return this.toFormat
      }
    },
  },

  computed: {
    fromFormat () {
      return moment(this.records.from, 'Y-MM-D').format('M/D/YY')
    },

    selectedRecords() {
      let selected = Object.assign({}, this.records)
      delete selected['from']
      delete selected['to']
      return selected
    },

    toFormat () {
      return moment(this.records.to, 'Y-MM-D').format('M/D/YY')
    },
  },
}
</script>
